module.exports = __webpack_public_path__ + "static/media/unlike.d0421b78.svg";